import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";

/**
 * Coming Soon placeholder — used for the future dashboard sections that
 * ship in later iterations (Collector Profile, Album Registry,
 * Certificate Registry, Collection Tracker, Saved Addresses).
 */
export default function ComingSoon({ title, description, Icon, testid }) {
  return (
    <div className="space-y-6" data-testid={testid || "coming-soon-page"}>
      <div>
        <div className="kicker kicker-red">Coming soon</div>
        <h1 className="h-display text-3xl md:text-4xl mt-1" data-testid={`${testid || "coming-soon"}-heading`}>
          {title}
        </h1>
      </div>

      <div className="rounded-2xl border-2 border-dashed border-[var(--ink)] bg-white p-10 text-center shadow-[4px_4px_0_var(--panini-yellow)]">
        <div className="mx-auto w-16 h-16 rounded-full bg-[var(--panini-yellow-soft)] border-2 border-[var(--ink)] grid place-items-center">
          {Icon ? <Icon size={26} className="text-[var(--panini-red)]" /> : <Sparkles size={26} className="text-[var(--panini-red)]" />}
        </div>
        <h2 className="font-display text-2xl mt-4">We&apos;re building this next.</h2>
        <p className="text-sm text-[var(--smoke)] mt-3 max-w-lg mx-auto">
          {description}
        </p>
        <p className="text-xs text-[var(--smoke)] mt-4 uppercase tracking-widest font-bold">
          Watch this space.
        </p>

        <Link
          to="/dashboard"
          className="btn-ghost text-sm mt-6 inline-flex"
          data-testid={`${testid || "coming-soon"}-back`}
        >
          <ArrowLeft size={14} /> Back to Dashboard
        </Link>
      </div>
    </div>
  );
}
